import { useState, useEffect } from 'react';

/**
 * Returns true once the component has mounted on the client.
 *
 * Use to keep the SSR/first-paint render consistent (avoiding a
 * hydration mismatch) when a decision depends on client-only state
 * such as viewport width.
 */
export default function useMounted() {
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
	}, []);

	return mounted;
}
